// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"b6a27e42","325":"85c868a9","970":"463d8b2a"}[chunkId] + ".chunk.css";
};